import { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { TextField, Button, DialogActions, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import { config as url } from "../../../common/config";
import AlertNotistack from "../../../components/molecules/AlertNotistack";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
	textField: {
		marginBottom: 16,
	},
	form: {
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: 4,
		backgroundColor: "white",
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
		padding: "18.5px 14px",
		width: "50%",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	formControl: {
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: 4,
		padding: "18.5px 14px",
		width: "100%",
	},
}));

const FormSetting = () => {
	const BaseUrl = `${url.list_email}`;
	const { enqueueSnackbar } = useSnackbar();
	const classes = useStyles();
	const fetchData = useContext(FetchDataContext);
	const { getFetchData, updateData } = fetchData;

	const [settingState, setSettingState] = useState({
		server: "",
		port: "",
		email: "",
		password: "",
		password2: "",
	});

	const { server, port, email, password, password2 } = settingState;

	const handleChangeSetting = (event) => {
		setSettingState({
			...settingState,
			[event.target.name]: event.target.value,
		});
	};

	const setupEmail = async () => {
		try {
			let result = await getFetchData({ url: BaseUrl });
			if (result) {
				setSettingState({
					server: result?.data?.server_email,
					email: result?.data?.email,
					port: result?.data?.port,
				});
			}
			return result;
		} catch (error) {
			throw error;
		}
	};

	useEffect(() => {
		setupEmail();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleOpenCloseFormAdd = () => {
		return true;
	};

	const swalSuccess = (e) => {
		e.preventDefault();
		Swal.fire({
			type: "success",
			title: "Anda yakin ingin mengubahnya?",
			icon: "warning",
			showCancelButton: true,
			cancelButtonText: "Tidak",
		}).then((result) => {
			if (result.value) {
				handleSubmit();
			}
		});
	};

	const handleSubmit = async () => {
		if (password !== password2) {
			enqueueSnackbar("Password doesn't match", AlertNotistack("error"));
		} else {
			try {
				const data = {
					...settingState,
					email: settingState.email,
					password: settingState.password,
					port: settingState.port,
					server: settingState.server,
				};
				const res = await updateData(
					`${BaseUrl}/update`,
					data,
					handleOpenCloseFormAdd
				);
				if (res.status === "success") {
					setupEmail();
					setSettingState({
						...settingState,
						password: "",
						password2: "",
					});
				}
			} catch (err) {
				enqueueSnackbar(err.message, AlertNotistack(err.status));
				throw err;
			}
		}
	};

	return (
		<form autoComplete="off" className={classes.form} onSubmit={swalSuccess}>
			<TextField
				required
				fullWidth
				variant="outlined"
				id="server"
				name="server"
				label="Server"
				className={classes.textField}
				value={server}
				onChange={handleChangeSetting}
			/>
			<TextField
				required
				fullWidth
				variant="outlined"
				id="port"
				name="port"
				label="Port"
				className={classes.textField}
				value={port}
				onChange={handleChangeSetting}
			/>
			<TextField
				required
				fullWidth
				variant="outlined"
				type="email"
				id="email"
				name="email"
				label="email"
				className={classes.textField}
				value={email}
				onChange={handleChangeSetting}
			/>
			<TextField
				required
				fullWidth
				variant="outlined"
				type="password"
				id="password"
				name="password"
				label="password"
				className={classes.textField}
				value={password}
				onChange={handleChangeSetting}
			/>
			<TextField
				required
				fullWidth
				variant="outlined"
				type="password"
				id="password2"
				name="password2"
				label="Retype Password"
				className={classes.textField}
				value={password2}
				onChange={handleChangeSetting}
			/>
			<DialogActions
				style={{
					width: "100%",
				}}
			>
				<Grid
					className="form-group"
					style={{
						display: "flex",
						justifyContent: "end",
					}}
				>
					<Button
						type="submit"
						// disabled={state.loading}
						variant="contained"
						color="primary"
					>
						Submit &#10148;
					</Button>
				</Grid>
			</DialogActions>
		</form>
	);
};

FormSetting.propTypes = {
	onSetSettingData: PropTypes.func.isRequired,
	data: PropTypes.objectOf.isRequired,
};

export default FormSetting;
